module.exports = __webpack_public_path__ + "img/logo.d2d0dd6f.png";